import { render, staticRenderFns } from "./AdvertiserPanelSquareBanner.vue?vue&type=template&id=477510ec&"
import script from "./AdvertiserPanelSquareBanner.vue?vue&type=script&lang=js&"
export * from "./AdvertiserPanelSquareBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports